export const environment = {
  production: false,
  baseUrl: 'https://planogeneticoapidev.altagenetics.com.br',
  apiBaseUrl: 'https://planogeneticoapidev.altagenetics.com.br/api',
  b2cRedirectUri: 'https://planogeneticoapidev.altagenetics.com.br',
  b2cPostLogoutRedirectUri: 'https://planogeneticoapidev.altagenetics.com.br',
  b2cClientId: 'd6d9572e-9873-436d-9896-d17da696ab9c',
  b2cLogin: 'altab2c.b2clogin.com',
  b2cDomain: 'altab2c.onmicrosoft.com',
  b2cApiClientId: 'd6d9572e-9873-436d-9896-d17da696ab9c',
  b2cSignUpSignIn: 'B2C_1_Common_SignupSignin_v1',
  b2cResetPassword: 'B2C_1_Common_PasswordReset_v1'
};